import React from "react"
import PropTypes from "prop-types"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"

import Input from "@irati/ui/src/FormItem/Input"
import Button, {TextButton} from "@irati/ui/src/Button"
import Validation from "@irati/utils/validation"
import {getTrimmed} from "@irati/utils/string/"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "importantInfo"
const placeholderText = "admin.components.companyBenefits.importantInformation.placeHolderText"

export const schema = () => Validation
  .string("admin.components.companyBenefits.importantInformation.schema.validation.string")

const handleDelete = (importantInfo, onChange, index) => {
  const clone = importantInfo.slice(0)
  clone.splice(index, 1)
  onChange(PROPERTY, clone)
}

const handleUpdate = (importantInfo, onChange, value, index) => {
  const clone = importantInfo.slice(0)
  clone[index] = value || ""
  onChange(PROPERTY, clone)
}

const handleBlur = (importantInfo, onChange, value, index) => {
  const newValue = getTrimmed(value) || ""
  handleUpdate(importantInfo, onChange, newValue, index)
}

const addStep = (importantInfo, onChange) => {
  const lastItem = importantInfo[importantInfo.length - 1]
  if (getTrimmed(lastItem).length) {
    handleUpdate(importantInfo, onChange, "", importantInfo.length)
  }
}

const removeButton = (importantInfo, onChange, index) => {
  return <TextButton onClick={() => handleDelete(importantInfo, onChange, index)}>
    <FormattedMessage id="admin.components.companyBenefits.importantInformation.removeButton.textButton" />
  </TextButton>
}

const hasMoreThanOneItem = (importantInfo) => {
  return importantInfo.length > 1
}

const ImportantInfo = ({benefit, onChange, formatMessage}) => {
  const importantInfo = [...benefit.importantInfo]
  if (importantInfo.length === 0) importantInfo.push("")

  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          { importantInfo.map((information, index) =>
            <StyledInput
              key={index}
              addon={{after: hasMoreThanOneItem(importantInfo) ? removeButton(importantInfo, onChange, index) : null}}
              name="importantInfo"
              label={formatMessage({id: "admin.components.companyBenefits.importantInformation.input.label"}, {count: index + 1})}
              type="text"
              validation={schema()}
              placeholder={placeholderText}
              value={information}
              onChange={(value) => handleUpdate(importantInfo, onChange, value, index)}
              onBlur={(value) => handleBlur(importantInfo, onChange, value, index)} />
          )}
          <Button full onClick={() => addStep(importantInfo, onChange)}>
            <FormattedMessage id="admin.components.companyBenefits.importantInformation.button.text" />
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}

ImportantInfo.propTypes = {
  benefit: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(ImportantInfo)
